import React from 'react';
import { TableProps as ChakraTableProps } from '@chakra-ui/react';
import { Container } from './styles';

interface TableProps extends ChakraTableProps {
  type?: 'primary' | 'secondary' | 'custom';
}

export const Table: React.FC<TableProps> = ({
  children,
  type = 'primary',
  ...props
}) => {
  return (
    <Container {...props} type={type}>
      {children}
    </Container>
  );
};
